import React from 'react';
import { useSelector } from 'react-redux'
import Aux from '../../hoc/Aux';
import * as actions from '../../store/actions/index';
import Navigation from './Navigation';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { useParams } from "react-router";
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import smartLogo from '../../BuildingSMART_CMYK_Germany_350.jpeg';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';


const projectHelp = (props) => {

  const ct = useCustomTranslation();
  let { projectId } = useParams();
  const ht = useCustomHtmlTranslation();

  const loading = useSelector(state => state.inventory.loading_project );

  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  let project = thisProject(projectId) || {};

  if ( !loading || project !== {}) {
    project = thisProject(projectId) || {};

    return (

    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
				<div className="col-xl-11 col-lg-11">
    					<div className="page-header">
              <h1 style={{fontSize: "1.0rem"}}>
                <span id="backlink"><Link to={ROUTES.TO_PROJECTS}>{ ct('project.navi.link.my_projects') }</Link></span> <i className="material-icons" style={{margin: "-5px", verticalAlign: "middle"}}>keyboard_arrow_right</i> {project.title}
              </h1>
    						<span className="lead"></span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
				<div className="col-xl-3 col-lg-3 mb-10">
              <Navigation activeItem="project_help" projectId={projectId} />
    				</div>

    				<div className="col-xl-8 col-lg-8 mb-10">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('account.navigation.to_project_help') }</h4>
                      <span style={{fontSize: "0.8em"}}>
                        { ht('content.help.bim') }
                        <br />
                        <a href="https://www.buildingsmart.de/buildingsmart/mitglieder/rudolf-hensel-gmbh" rel="noopener noreferrer" target="_blank">
                          <img src={smartLogo} alt="buildingsmart-logo" />
                        </a>
                      </span>

    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  )
} else {
 return null;
}


};

export default projectHelp;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectHelp.js